import { ISku, ISkuInput } from "@/interfaces/sku.interface";
import IProductVariation from "@/interfaces/variation.interface";
import { ProductFormPageMessages } from "@/messages/products/product-form-page.messages";
import { ProductFormMessages } from "@/messages/products/product-form.messages";
import { SkuTableMessages } from "@/messages/sku/sku-table.messages.";
import { FilterType, IFilter } from "@/types/filter.types";
import { SelectData, TabItem } from "@/types/form.types";

import { ProductTabs, SkuTabs } from "./types";

export const PRODUCT_TABS_ITEMS = (messages: ProductFormPageMessages): TabItem<ProductTabs>[] => {
  const { productInfoTabLabel, productSkuTabLabel } = messages;

  const tabs: TabItem<ProductTabs>[] = [
    { value: "productInfoTab", label: productInfoTabLabel },
    { value: "productSkuTab", label: productSkuTabLabel },
  ];

  return tabs;
};

export const SKU_TABLE_COLUMNS = (messages: SkuTableMessages) => {
  return [
    messages.codeColumn,
    messages.nameColumn,
    messages.stockolumn,
    messages.priceColumn,
    messages.statusColumn,
    messages.optionsColumn,
  ];
};

export const SKU_TABS_ITEMS = (
  messages: ProductFormPageMessages,
  isEditingSku: boolean,
  showKitTab: boolean,
  sku?: ISkuInput | ISku | null
): TabItem<SkuTabs>[] => {
  const { productSkuTabLabel, kitTabLabel } = messages;

  const tabs: TabItem<SkuTabs>[] = [{ value: "skuTab", label: productSkuTabLabel }];

  if ((isEditingSku && sku?.kit) || showKitTab) {
    tabs.push({ value: "kitTab", label: kitTabLabel });
  }

  return tabs;
};

export const initialValue: IFilter<IProductVariation>[] = [
  {
    property: "description",
    value: "",
    filterType: FilterType.Contains,
  },
];

export const PRODUCT_VARIATION_OPTIONS = (
  messages: ProductFormMessages,
  productVariations?: IProductVariation[]
): SelectData<string>[] => {
  const options: SelectData<string>[] = [];

  if (productVariations) {
    const variationOptions = productVariations.map((variation) => {
      return { value: variation.id.toString(), label: variation.description };
    });

    options.push(...variationOptions);
  }

  return options;
};
